import { useMemo } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { Group, LoadingOverlay, Stack, Text } from "@mantine/core";
import BackButton from "../../../../../../components/View/BackButton";
import UnsubCronItem from "./UnsubCronItem";
import CreateUnsubCron from "./CreateUnsubCron";

const UnsubCronsContent = ({
  handleClose,
  defaultFilter,
  loading,
  setLoading,
  crons,
}) => {
  const lang = useLanguage((s) => s.language);
  const items = useMemo(() => {
    return crons.filter((x) => x.type === "contactlists_copy_to_unsubscribers");
  }, [crons]);

  return (
    <>
      <Stack pos={"relative"} gap={"xs"} h={"100%"} flex={1}>
        <LoadingOverlay visible={loading} />

        <Text c={"dimmed"}>{lang.contact_lists.cron.text_unsub}</Text>

        {items.length > 0 ? (
          <Group
            gap={"lg"}
            mah={"58vh"}
            style={{ overflow: "auto" }}
            align="start"
          >
            {items.map((item, index) => {
              return (
                <UnsubCronItem
                  key={item.id}
                  item={item}
                  handleReload={() => setLoading(true)}
                />
              );
            })}
          </Group>
        ) : (
          <Stack>
            <Text c={"dimmed"} size="lg" ta={"center"} mt={64}>
              {lang.contact_lists.cron.no_cron_found}
            </Text>
            <CreateUnsubCron
              handleDone={() => setLoading(true)}
              variant="light"
              w={300}
              mx="auto"
              defaultFilter={defaultFilter}
            />
          </Stack>
        )}
      </Stack>

      <Group justify="end" mt={"lg"}>
        <BackButton onClick={handleClose} size="md" />
        <CreateUnsubCron
          handleDone={() => setLoading(true)}
          defaultFilter={defaultFilter}
        />
      </Group>
    </>
  );
};

export default UnsubCronsContent;
